import { twMerge } from "tailwind-merge";

import { Stack } from "../../Layouts";
import { StackProps } from "../../Layouts/Stack/Stack.types";

function MenuContent({
  className,
  ...props
}: StackProps) {

  return (
    <Stack className={twMerge("px-6 py-4 border w-full", className)} {...props} />
  );
}

MenuContent.defaultProps = {
  direction: 'row'
} as StackProps;

export { MenuContent }
